import axios from 'axios'
import store from '../store'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = process.env.VUE_APP_BASE_URL
const testUrl = localStorage.getItem(TEST_URl)
const baseUrl = testUrl || defaultBaseUrl

export async function initiateTransferService (userData) {
  const res = await axios.post(`${baseUrl}/transfers`, { ...userData })
  return res
}
export async function initiateAssetTransferService (userData) {
  const res = await axios.post(`${baseUrl}/transfers/asset`, { ...userData })
  return res
}

export async function resolveAccountService (accountData) {
  const res = await axios.get(
    `${baseUrl}/utils/resolve-account-name?account_number=${accountData.account_number}&bank_code=${accountData.bank_code}&currency=${accountData.currency}`
  )
  return res
}

export async function validatePhoneNumberService (payload) {
  const res = await axios.get(
    `${baseUrl}/utils/validate-phone-number?phoneNumber=${payload.phoneNumber}&countryCode=${payload.countryCode}`
  )
  return res
}

export async function getBeneficiaryService (payload) {
  const hasTransferDestination = payload.transfer_destination
    ? `&transfer_destination=${payload.transfer_destination}`
    : ''
  const res = await axios.get(
    `${baseUrl}/transfers/beneficiaries?size=${payload.size}&page=${payload.page}${hasTransferDestination}`
  )
  return res
}

export async function saveBeneficiaryService () {
  const transferId = store.state.terminal.transferInfo.transfer.id
  const res = await axios.post(
    `${baseUrl}/transfers/save-beneficiary/${transferId}`,
    {}
  )
  return res
}
export async function deleteBeneficiaryService (id) {
  const res = await axios.post(
    `${baseUrl}/transfers/delete-beneficiary/${id}`,
    {}
  )
  return res
}

export async function uploadTransferDocumentService (payload) {
  const transferId = store.state.transactions.transactionDetails.transferID
  const transferDocumentId = payload.documentID
  // const transferDocumentId = store.state.transactions.transactionDetails.transferDocument[0].id
  const res = await axios.post(
    `${baseUrl}/transfers/${transferId}/${transferDocumentId}`,
    payload.formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return res
}

export async function getSupportedBanksService (payload) {
  const res = await axios.get(
    `${baseUrl}/utils/supported-banks?currency=${payload.currency}&payoutType=${payload.payoutType}`
  )
  return res
}
export async function getDateRateServices (payload) {
  const res = await axios.get(
    `${baseUrl}/utils/rate?from=${payload.from}&to=${payload.to}&date=${payload.date}`
  )
  return res
}
export async function submitQuestionnaireService (payload) {
  const res = await axios.post(`${baseUrl}/transfers/questionnaire`, payload)
  return res
}
export async function processTransferService (payload) {
  const res = await axios.post(
    `${baseUrl}/transactions/requests/process`,
    payload
  )
  return res
}

export async function getSupportedCountriesService () {
  const res = await axios.get(`${baseUrl}/utils/supported-countries`)
  return res
}
